module.exports = __webpack_public_path__ + "static/media/minus.b3400827.svg";